import { showToast } from "../components/toast.component";
import { ApiResponseContainer } from "../models/api";

export function parseErrorMessage(error: any, duration?: number) {
  const response = JSON.parse(error.message);
  const data = response.data as ApiResponseContainer<null>;
  const message = data?.message;
  try {
    // Parse the main JSON message
    const parsedMessage = JSON.parse(message!);

    // Extract transaction ID
    const transactionId = parsedMessage.transactionId || "N/A";
    console.log(`Transaction ID: ${transactionId}`);

    // Extract and print errors if they exist
    const errors = parsedMessage.errors || [];
    if (errors.length > 0) {
      console.log("Errors:");
      errors.forEach((error: any) => {
        const code = error.code || "Unknown Code";
        const errorMessage = error.message || "No message provided";
        console.log(`Code: ${code}, Message: ${errorMessage}`);
        showToast(errorMessage, "error", "bottomEnd", duration, true);
      });
    } else {
      showToast(
        parsedMessage.error || "No errors found in the message.",
        "error",
        "bottomEnd",
        duration,
        true
      );
    }
  } catch (e) {
    console.log(
      "Failed to parse JSON. Attempting to find specific error messages."
    );

    // Handle expired token error or other raw string errors
    if (/Token is expired/i.test(message!)) {
      showToast(
        "Token is expired. Please create a new token and try again.",
        "error",
        "bottomEnd",
        duration,
        true
      );
    } else {
      showToast(
        "Unable to parse the message. Here is the raw message:",
        "error",
        "bottomEnd",
        duration,
        true
      );
      console.log(error);
      console.log(message);
    }
  }
}

export const UtilityError = {
  parseErrorMessage,
};
